import { Link } from 'react-router-dom';
import classes from './ErrorPages.module.css';
import errorImage from '../../public/icons/errorIcons/error500.png';
import studioLogo from '../../public/icons/stu-logo.svg';

const ServerError = () => {
  return (
    <div className={classes.errorPageContainer}>
        <header className={classes.headerContainer}>
            <div className={classes.studioLogoContainer}>
                <Link to="/">
                    <img src={studioLogo} alt="Studio Logo" />
                </Link>
            </div>
        </header>
        <div className={classes.errorContainer}>
            <div className={classes.errorContent}>
                <h3>Fehlercode: 500</h3>
                <h1>Etwas ist schief gelaufen...</h1>
                <h4>Das perfekte Studio findest du aber trotzdem!</h4>
                <div className={classes.errorButtonContainer}>
                    <Link to="/" className={`${classes.homeButton} regularLarge`}>
                        Zur Startseite
                    </Link>
                    <Link to="/kontakt" className={`${classes.helpButton} regularLarge`}>
                        Hilfe
                    </Link>
                </div>
            </div>
            <div className={classes.errorImageContainer}>
                <img src={errorImage} alt="500 Error" />
            </div>
        </div>
    </div>
  );
};

export default ServerError;